import { CAD, USD } from '@dinero.js/currencies';
import { Currency } from 'dinero.js';

import { logError } from '@/imports/logging/ClientLogger';

export enum ApiSupportedCurrencyValues {
  USD = 'usd',
  CAD = 'cad',
}

export const getCurrencyFromCurrencyCode = (
  code: ApiSupportedCurrencyValues
): Currency<number> => {
  switch (code) {
    case ApiSupportedCurrencyValues.USD: {
      return USD;
    }
    case ApiSupportedCurrencyValues.CAD: {
      return CAD;
    }
    default: {
      logError(new Error(`Could not parse api currency code ${code}`));
      return USD;
    }
  }
};
